export const FINANCE = {
  path: 'finance',
  data: {
    breadcrumb: 'MENU_ADMIN.FINANCE',
    icon: 'pi pi-money-bill',
    clickable: false,
    openTab: true
  },
  dashboard: {
    path: 'dashboard',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.DASHBOARD',
      icon: 'pi pi-chart-bar',
      openTab: true
    }
  },
  invoices: {
    path: 'invoices',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.INVOICES',
      icon: 'pi pi-file-edit',
      openTab: true
    }
  },
  payments: {
    path: 'payments',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.PAYMENTS',
      icon: 'pi pi-dollar',
      openTab: true
    }
  },
  collections: {
    path: 'collections',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.COLLECTIONS',
      icon: 'pi pi-chart-line',
      openTab: true
    }
  },
  unitStatements: {
    path: 'unit-statements',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.UNIT_STATEMENTS',
      icon: 'pi pi-book',
      openTab: true
    }
  },
  expenses: {
    path: 'expenses',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.EXPENSES',
      icon: 'pi pi-credit-card',
      openTab: true
    }
  },
  transactions: {
    path: 'transactions',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.TRANSACTIONS',
      icon: 'pi pi-arrows-h',
      openTab: true
    }
  },
  accounts: {
    path: 'accounts',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.ACCOUNTS',
      icon: 'pi pi-wallet',
      openTab: true
    }
  },
  banks: {
    path: 'banks',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.BANKS',
      icon: 'pi pi-building',
      openTab: true
    }
  },
  budgets: {
    path: 'budgets',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.BUDGETS',
      icon: 'pi pi-calculator',
      openTab: true
    }
  },
  bankReconciliation: {
    path: 'reconciliation',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.BANK_RECONCILIATION',
      icon: 'pi pi-check-circle',
      openTab: true
    }
  },
  dgii: {
    path: 'dgii',
    data: {
      breadcrumb: 'MENU_ADMIN.FINANCE_SUB.ELECTRONIC_INVOICING_DGII',
      icon: 'pi pi-globe',
      openTab: true
    }
  }
};
